import React, { useEffect, useState } from "react";
import LabelInput from '../../../Component/labelInput';
import PageTitle from '../../../module/pageTitle';
import { InputField, Submitbtn } from '../../../Component';
import { addDesignation } from '../superAdminSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from "../../../store";
import { validateIsLettersAndDigitsSpaceOnly } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const AddDesignation = () => {
    const dispatch: Function = useDispatch<AppDispatch>();
    const [designationName, setDesignationName] = useState<string>("");
    const [level, setLevel] = useState<any>("");
    const onChangeDesignationName = (val: any) => {
        if (validateIsLettersAndDigitsSpaceOnly(val)) {
            setDesignationName(val);
        }

    }
    const onChangeDesignationLevel = (val: any) => {
        if (validateIsLettersAndDigitsSpaceOnly(val)) {
            setLevel(val)
        }

    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const postData = {
            name: designationName,
            level: level
        };
        dispatch(
            addDesignation({
                params: postData,
                callback: (res: any) => {
                    if (res?.status === "success") {
                        setDesignationName("")
                        setLevel("");
                        dispatch(showSnackbar({ message: "Designation added Successfully", type: res?.data?.status }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    }
                },
                errorCallback: (error: any) => {
                    dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);

                },
            })
        );
    };

    const validations = () => {
        return designationName === "" || level === ""
    };

    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Add Designation"}
                    breadCrumb={''}
                    isEditMode={false}
                    cancelEdit={() => ('')} />
            </div>
            <div className='formDiv' onSubmit={handleSubmit}>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    <form>
                        <div className='row align-items-center'>
                            <div className='col-md-4'>
                                <LabelInput labelName={"Designation Name"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Designation Name"}
                                    setInputText={(value: any) => onChangeDesignationName(value)}
                                    value={designationName}
                                />
                            </div>
                            <div className='col-md-4'>
                                <LabelInput labelName={"Designation Level"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Desigantion Level"}
                                    setInputText={(value: any) => onChangeDesignationLevel(value)}
                                    value={level}
                                />
                            </div>
                            <div className='col-md-2'>
                                <LabelInput labelName={""} />
                                <Submitbtn name={"Add"} disabled={validations()} />
                            </div>
                        </div>
                    </form>
                </div >
            </div >
        </div >
    );
}

export default AddDesignation;